<template>
  <div>
    <!-- Add RISQ-Finding Modal -->
    <div class="modal fade" id="nonConformityNew" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder">Add Finding</h5>
            <button type="button" class="close" data-dismiss="modal" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <!-- Revision Number Select -->
            <div class="form-group row no-gutters mb-1">
              <label class="font-weight-bold col-sm-2 col-form-label">
                Revision Number
                <span v-if="!selectedRevisionId" class="text-danger h5">*</span>
              </label>
              <div class="col-sm-10">
                <select
                  v-model="selectedRevisionId"
                  @change="onRevisionChange"
                  class="form-control form-control-sm"
                >
                  <option disabled value="">-- SELECT REVISION NUMBER --</option>
                  <option
                    v-for="rev in revisions"
                    :key="rev.id"
                    :value="rev.id"
                    v-show="rev.id !== selectedRevisionId"
                  >
                    v{{ rev.revision_number }}
                  </option>
                </select>

              </div>
            </div>

            <!-- Question Select Button -->
            <div class="form-group row no-gutters mb-1">
              <label class="font-weight-bold col-sm-2 col-form-label">
                RISQ-Finding Question
                <span v-if="!selectedRevisionId || filteredQuestions.length === 0" class="text-danger h5">*</span>
              </label>
              <div class="col-sm-10">
                <button
                  class="btn border btn-block text-left btn-sm"
                  data-toggle="modal"
                  data-target="#nonConformityLists"
                  type="button"
                  :disabled="!selectedRevisionId || filteredQuestions.length === 0"
                >
  <span>
    {{ code?.id
    ? code.code.toUpperCase() + ' - ' + code.main_question.toUpperCase()
    : '--- SELECT RISQ-FINDING QUESTION ---' }}
  </span>
                  <span style="float: right">
    <font-awesome-icon icon="chevron-down" />
  </span>
                </button>
                <small v-if="!selectedRevisionId" class="text-danger">
                  Please select a revision number first.
                </small>
                <small v-else-if="filteredQuestions.length === 0" class="text-danger">
                  No available questions for the selected revision.
                </small>
              </div>
            </div>
            <div class="form-group row no-gutters mb-1 mt-2">
              <label for="NonConformityQuestioner" class="font-weight-bold col-sm-2 col-form-label">Type of Finding
                <span v-if="!fields.type_of_finding" class="text-danger h5">*</span>
              </label>
              <div class="col-sm-10">
                <select class="form-control form-control-sm" v-model="fields.type_of_finding">
                  <option disabled :value="null">--- SELECT FINDING ---</option>
                  <option :value="'Deficiency'">Deficiency</option>
                  <option :value="'Observation'">Observation</option>
                  <option :value="'Recommendation'">Recommendation</option>
                </select>
              </div>
            </div>
            <div class="form-group row no-gutters mb-1 mt-2">
              <label for="NonConformityQuestioner" class="font-weight-bold col-sm-2 col-form-label">Severity Level
                <span v-if="!fields.severity_level" class="text-danger h5">*</span>
              </label>
              <div class="col-sm-10">
                <select class="form-control form-control-sm" v-model="fields.severity_level">
                  <option disabled :value="null">--- SELECT SEVERITY ---</option>
                  <option :value="'Low'">Low</option>
                  <option :value="'Medium'">Medium</option>
                  <option :value="'High'">High</option>
                </select>
              </div>
            </div>
            <!-- Description -->
            <div class="form-group row no-gutters mb-1">
              <label class="font-weight-bold col-sm-2 col-form-label">RISQ-Finding Description</label>
              <div class="col-sm-10" id="ncr-description-editor">
                <vue-editor class="my-2" v-model="fields.description" :editor-toolbar="toolbar" />
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" @click="saveRsnc">Save</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Question Selector Modal -->
    <div class="modal fade" id="nonConformityLists" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">SELECT RISQ-FINDING QUESTION</h5>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body overflow-auto" style="height: 50vh">
            <template v-if="filteredQuestions.length">
              <rsnc-question-component
                v-for="(node, index) in filteredQuestions"
                :key="node.id || index"
                :rsnc-code="code"
                :node="node"
                @setQuestion="setRsncQuestion"
              />
            </template>
            <p v-else class="text-center text-muted">No questions available for selected revision.</p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal">Select</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import RsncQuestionComponent from "@/components/modules/rightship/RsncQuestionComponent.vue";
import { AlertService } from "@/services/AlertService";

export default {
  name: "NonConformityAdd",
  components: { RsncQuestionComponent },
  data() {
    return {
      selectedRevisionId: '',
      code: {},
      fields: {
        rs_id: this.$route.params.id,
        description: '',
        rsn_question_id: null,
        type_of_finding: null,
        severity_level: null,
        revision_number_id: null
      },
      toolbar: [
        ['bold', 'italic', 'strike', 'underline'],
        [{
          'color': [
            "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"
          ]
        }]
      ]
    };
  },
  computed: {
    ...mapGetters(['rsncQuestionKeys']),
    ...mapState({
      revisions: state => state.RevisionModule.revisions
    }),
    filteredQuestions() {
      const filtered = this.filterByRevision(this.rsncQuestionKeys);
      const sortCodes = (nodes) => {
        return nodes
          .slice()
          .sort((a, b) => this.compareCode(a.code, b.code))
          .map(node => ({
            ...node,
            children: node.children ? sortCodes(node.children) : []
          }));
      };
      return sortCodes(filtered);
    }
  },
  methods: {
    ...mapActions({
      fetchRevisions: 'fetchRevisions',
      fetchNonConformityByRevisionId: 'fetchNonConformityByRevisionId',
      saveRsNonConformity: 'saveRsNonConformity'
    }),

    async onRevisionChange() {
      if (this.selectedRevisionId) {
        await this.fetchNonConformityByRevisionId(this.selectedRevisionId);
        this.code = {};
        this.fields.rsn_question_id = null;
      }
    },

    filterByRevision(nodes) {
      return nodes
        .map(node => {
          const children = node.children ? this.filterByRevision(node.children) : [];
          const match = node.revision_number_id === this.selectedRevisionId;
          if (match || children.length > 0) {
            return { ...node, children };
          }
          return null;
        })
        .filter(n => n !== null);
    },

    compareCode(a, b) {
      const parse = (code) => code?.split('.').map(num => parseInt(num, 10));
      const [aParts, bParts] = [parse(a), parse(b)];

      for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
        const diff = (aParts[i] || 0) - (bParts[i] || 0);
        if (diff !== 0) return diff;
      }
      return 0;
    },

    setRsncQuestion(value) {
      this.code = value;
      this.fields.rsn_question_id = value.id;
    },

    async saveRsnc() {
      if (!this.fields.rsn_question_id) {
        return AlertService.errorAlert('RISQ-Finding Question is required!', 'Add RISQ-Finding');
      }
      else if (!this.fields.type_of_finding) {
        return AlertService.errorAlert('Type of finding is required!', 'Add RISQ-Finding');
      }
      else if (!this.fields.severity_level) {
        return AlertService.errorAlert('Severity level is required!', 'Add RISQ-Finding');
      }

      this.fields.revision_number_id = this.selectedRevisionId;

      if (await AlertService.confirmCreateAlert('Do you want to create new RISQ-Finding?')) {
        const response = await this.saveRsNonConformity(this.fields);
        if (response) {
          AlertService.successAlert('RISQ-Finding added successfully', 'Add RISQ-Finding');
          Object.assign(this.$data, this.$options.data.apply(this));
          $('#nonConformityNew').modal('hide');
          this.$emit('loadPage');
        }
      }
    },

    closeModal() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  },
  created() {
    this.fetchRevisions();
  }
};
</script>

<style scoped>
#ncr-description-editor {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
